import React, { useState, useEffect, useContext } from "react";
import { getUser, editUser } from "../api";
import { useParams } from "react-router-dom";
import { AuthContext } from "../AuthContext";

export default function EditUser() {
  const { user: authUser } = useContext(AuthContext);
  const token = authUser?.token;
  const { id } = useParams();

  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmaSenha, setConfirmaSenha] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingUser, setLoadingUser] = useState(true); // 👈 novo estado

  // Carregar dados do usuário
  useEffect(() => {
    async function fetchUser() {
      try {
        const user = await getUser(id, token);
        setNome(user.nome);
        setEmail(user.email);
      } catch (error) {
        setMsg({
          type: "error",
          text: "Erro ao carregar usuário: " + error.message,
        });
      } finally {
        setLoadingUser(false); // 👈 para o spinner
      }
    }
    fetchUser();
  }, [id, token]);

  async function handleSubmit(e) {
    e.preventDefault();
    setMsg(null);

    if (senha && senha !== confirmaSenha) {
      setMsg({ type: "error", text: "A confirmação da senha não confere." });
      return;
    }

    setLoading(true);
    try {
      await editUser(id, nome, email, senha || null, token);
      setMsg({ type: "success", text: "Usuário atualizado!" });
      setSenha("");
      setConfirmaSenha("");
    } catch (error) {
      setMsg({ type: "error", text: error.message });
    } finally {
      setLoading(false);
    }
  }

  // Enquanto carrega os dados, exibe o spinner
  if (loadingUser) {
    return (
      <div className="page-container center-content">
        <div className="spinner"></div>
        <p>Carregando usuário...</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="dashboard-container">
        <div className="user-grid">
          <div className="user-card">
            <h3>Editar Usuário</h3>
            <form onSubmit={handleSubmit} className="card-actions">
              <div className="form-group labels">
                <label>Nome</label>
                <input
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Digite o nome do usuário"
                  required
                />
                <label>Email</label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Digite o email do usuário"
                  required
                />
                <label>Nova Senha (opcional)</label>
                <input
                  type="password"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  placeholder="Digite uma nova senha"
                />
                <label>Confirmar Senha</label>
                <input
                  type="password"
                  value={confirmaSenha}
                  onChange={(e) => setConfirmaSenha(e.target.value)}
                  placeholder="Confirme a senha"
                />
              </div>

              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? <span className="spinner"></span> : "Atualizar"}
              </button>

              {msg && (
                <div
                  className={
                    msg.type === "error" ? "error-msg" : "success-msg"
                  }
                >
                  {msg.text}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
